import { RouteObject } from "react-router-dom";
import NFCeView from "./NFCe.View";
import NFCeConsultaView from "./Consulta/NFCe.Consulta.View";

export const NFCeRoutes: RouteObject[] = [
  {
    path: "fiscal/nfce",
    element: <NFCeView />,
  },
  {
    path: "fiscal/nfce/consulta",
    element: <NFCeConsultaView />,
  },
];
